module.exports = function($scope, objectResolve) {
  $scope.resources = objectResolve;
  // TODO: check number of licences
  $scope.showPremiumNotification = $scope.subscription.onlyBasicFunctions;
  $scope.roomsExists = $scope.resources.some(function(resource) {
    return resource.type === 'room';
  });
};



// WEBPACK FOOTER //
// ./src/app/modules/resources/ResourcesListCtrl.js